import { render, staticRenderFns } from "./ImagePlusIcon.vue?vue&type=template&id=3ccf40d3"
import script from "./ImagePlusIcon.vue?vue&type=script&lang=js"
export * from "./ImagePlusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports